import {Component} from '@angular/core';
import {SvgSpriteIcon} from '../svg-sprite';

@Component({
  selector: 'lib-modal-content',
  standalone: true,
  templateUrl: './modal-content.component.html',
  styleUrl: './modal-content.component.scss',
})
export class ModalContentComponent {
  protected readonly SvgSpriteIcon = SvgSpriteIcon;
}
